"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu/Menu.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)(({
  palette
}) => {
  const topBarColor = palette.background.topBar;
  return {
    menu: {
      backgroundColor: topBarColor
    }
  };
});
const initState = {
  mouseX: null,
  mouseY: null
};
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(function ContextMenu({
  items,
  children,
  className,
  menuClass
}, ref) {
  const classes = useStyles({});
  const [state, setState] = _react.default.useState(initState);
  if (!items?.length) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    className: className,
    children: children
  });
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
  };
  const handleClose = e => {
    e.stopPropagation();
    setState(initState);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    className: className,
    onContextMenu: handleClick,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.default, {
      classes: {
        list: (0, _classnames.default)(classes.menu, menuClass)
      },
      open: state.mouseY !== null,
      onClose: handleClose,
      anchorReference: "anchorPosition",
      anchorPosition: state.mouseY !== null && state.mouseX !== null ? {
        top: state.mouseY,
        left: state.mouseX
      } : undefined,
      children: items.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        closeMenu: handleClose,
        item: item
      }, item.name))
    })]
  });
});